import { Component, Input } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { take } from 'rxjs';

@Component({
  selector: 'app-daily-routine',
  templateUrl: './daily-routine.component.html',
  styleUrls: ['./daily-routine.component.scss'],
})
export class DailyRoutineComponent {
  @Input() userUID: string | undefined;
  dailyRoutine: any;
  personal = '../../../../assets/images/routine.png';
  constructor(private firestore: AngularFirestore) {}

  ngOnInit(): void {
    this.getPersonalInfo();
  }

  getPersonalInfo() {
    this.firestore
      .collection('dailyRoutine')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        let obj = data.data();
        console.log(obj);
        // obj.firstName = obj.firstName + ' ' + obj.lastName;
        this.dailyRoutine = obj;
      });
  }
}
